// extracted by mini-css-extract-plugin
export var accent = "FeaturedMedia-module--accent--789a8";
export var contained = "FeaturedMedia-module--contained--b66bc";
export var content = "FeaturedMedia-module--content--2b860";
export var contentContainer = "FeaturedMedia-module--contentContainer--f6d6d";
export var ctaContainer = "FeaturedMedia-module--ctaContainer--6076a";
export var featured = "FeaturedMedia-module--featured--fd416";
export var featuredimage = "FeaturedMedia-module--featuredimage--737e5";
export var image = "FeaturedMedia-module--image--1f530";
export var imageRight = "FeaturedMedia-module--imageRight--71c7b";
export var roundBottom = "FeaturedMedia-module--roundBottom--4b7f6";
export var roundTop = "FeaturedMedia-module--roundTop--ddf25";
export var secondaryCta = "FeaturedMedia-module--secondaryCta--614bb";
export var vector = "FeaturedMedia-module--vector--7fdf0";
export var vectorBottom = "FeaturedMedia-module--vectorBottom--5761f";